import { Resource } from "@prisma/client";
import { useState } from "react";

const ShowImageIfPresent = ({
  image,
  alt,
  className,
  imageNotPresentChildren,
}: {
  image: Resource | null;
  alt: string;
  className: string;
  imageNotPresentChildren?: React.ReactElement;
}) => {
  const [shouldShow, setShouldShow] = useState(true);

  if (!image) {
    return imageNotPresentChildren || null;
  }

  if (image && shouldShow) {
    return (
      <img
        src={image.webpUrl || image.url || undefined}
        alt={alt}
        className={className}
        onError={() => setShouldShow(false)}
      />
    );
  }

  if (imageNotPresentChildren) {
    return imageNotPresentChildren;
  }

  return null;
};

export default ShowImageIfPresent;
